import script from "./InvestorRelations.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestorRelations.vue?vue&type=script&setup=true&lang=js"

import "./InvestorRelations.vue?vue&type=style&index=0&id=83306286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83306286"]])

export default __exports__